<div [formGroup]="form">
  <input type="text"  formControlName="datebox" name="datebox" placeholder="mm/dd/yyyy or yyyy" (blur)="onBlur($event)" />
</div>
